import { Injectable } from "@angular/core";
import { IDataSource } from "./datasource.abstract";
import { Observable, of } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
import { IExecutionQueryResult, QueryCatalogEntry } from "@common/interfaces/query";

@Injectable({
  providedIn: 'any',
})
export class QueryDataSource implements IDataSource {
  public readonly name = 'QUERY';
  constructor(
    private http: HttpClient
  ) { }
  getOptions$(queryOptions: { queryId: string, optionValue?: string, optionLabel: string }): Observable<{ value: string, label: string, source: any }[]> {
    const { queryId, optionLabel, optionValue } = queryOptions
    if (!queryId || !optionLabel || !optionValue) {
      return of([]);
    }
    const options = this.http.post<IExecutionQueryResult>(`/api/query-access/${queryId}/run`, { params: {} }).pipe(
      map(response => (response.items ?? []).map(item => ({ value: item[optionValue], label: item[optionLabel], source: item }))),
      catchError(() => of([]))
    );
    return options;
  }
  getOptionsForQuerySelect(): Observable<{ value: string, label: string }[]> {
    return this.http.get<QueryCatalogEntry[]>('/api/query-access').pipe(
      catchError(err => ([])),
      map((queries => {
        if (!queries) {
          return [];
        }
        return queries.sort((a, b) => a.name.localeCompare(b.name)).map(q => ({ value: q.id, label: q.name }));
      }))
    );
  }
}
